import { styled } from "@mui/material";
import MAccordion, { accordionClasses } from "@mui/material/Accordion";
import MAccordionActions from "@mui/material/AccordionActions";
import MAccordionDetails from "@mui/material/AccordionDetails";
import MAccordionSummary, { accordionSummaryClasses } from "@mui/material/AccordionSummary";
import { colors } from "@zapalacorp/tokens";

export const Container = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  marginTop: "24px",
  borderRadius: "8px !important",
  overflow: "hidden",
  border: `1px solid ${colors.gray200}`,
}));

export const Accordion = styled(MAccordion)(() => ({
  "&:before": {
    display: "none",
  },
  [`&.${accordionClasses.root}`]: {
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",
  },
  [`&.${accordionClasses.expanded}`]: {
    margin: "0 !important",
  },
  [`&:not(:first-of-type) .${accordionSummaryClasses.root}`]: {
    borderTop: `1px solid ${colors.gray200}`,
  },
}));

export const AccordionSummary = styled(MAccordionSummary)(() => ({
  padding: "16px !important",
  backgroundColor: colors.gray50,

  color: colors.gray600,
  fontWeight: 400,
  lineHeight: "24px",
  fontSize: "16px",
  letterSpacing: "0.5px",
  height: "56px",
  fontFamily: "Manrope",

  [`&.${accordionSummaryClasses.root}`]: {
    minHeight: "auto !important",
  },

  [`& .${accordionSummaryClasses.content}`]: {
    margin: "0 !important",
  },
}));

export const AccordionDetails = styled(MAccordionDetails)(() => ({
  padding: "16px !important",
  borderTop: `1px solid ${colors.gray200}`,
}));

export const AccordionActions = styled(MAccordionActions)(() => ({}));

export const MandatoryFieldTitle = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: "0.1px",
  color: colors.gray500,
}));

export const MandatoryFieldDisplay = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "20px",
  letterSpacing: "0.1px",
  color: colors.gray600,
}));

export const MilitaryOnlyHeader = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
}))

export const TemplateTypeBadge = styled("div", {
  shouldForwardProp: (props) => props !== "isCustom",
})(({ isCustom }: { isCustom: boolean }) => ({
  border: `1px solid ${isCustom ? colors.warning600 : colors.success600}`,
  backgroundColor: isCustom ? colors.warning25 : colors.success25,
  color: isCustom ? colors.warning600 : colors.success600,
  borderRadius: "8px",
  font: "600 14px Manrope",
  padding: "10px",
  gap: "8px",
  display: "flex",
  alignItems: "center",
  width: "fit-content",
}));

export const TemplateTypeBadgeDot = styled("span", {
  shouldForwardProp: (props) => props !== "isCustom",
})(({ isCustom }: { isCustom: boolean }) => ({
  height: "8px",
  width: "8px",
  borderRadius: "50%",
  backgroundColor: isCustom ? colors.warning600 : colors.success600,
}));

export const MilitaryPermissionInfo = styled("div")(() => ({
  border: `1px solid ${colors.brandBlue600}`,
  backgroundColor: colors.brandBlue25,
  color: colors.brandBlue600,
  borderRadius: "8px",
  font: "600 14px Manrope",
  padding: "10px",
  gap: "10px",
  display: "flex",
  alignItems: "center",
}))

export const MilitaryReport = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
}))

export const MilitaryReportTitle = styled("span")(() => ({
  font: "700 16px Manrope",
  color: colors.black,
}))

export const MilitaryReportDescription = styled("span")(() => ({
  font: "600 14px Manrope",
  color: colors.gray600,
}))
